import type { Tokens } from '../../../theming/types'
import { styles } from '../../../utilities'
import type { InputTextBoxProps } from '..'

export default (config: {
  props?: Partial<InputTextBoxProps>
  tokens: Tokens
}) => {
  const { tokens } = config
  return {
    default: {
      wrapper: {
        display: 'flex',
        background: tokens.formControlBgColorDefault,
        border: `1px solid ${tokens.formControlBorderColorDefault}`,
        borderRadius: '2px',
        width: '100%',
        outline: '1px solid transparent',
        outlineOffset: `-${tokens.focusWidth}`,
        transitionDuration: '100ms',
        transitionProperty: 'border, outline',

        '&:hover': {
          borderColor: tokens.formControlBorderColorHover,
        },
      },

      input: {
        ...tokens.fontBodyM,
        textOverflow: 'ellipsis',
        width: '100%',
        appearance: 'none',
        background: 'transparent',
        border: 'none',
        color: tokens.fontColorDefault,
        height: 'auto',
        margin: 0,

        /* remove chrome's default date/time icons */
        '::-webkit-calendar-picker-indicator': {
          display: 'none',
        },

        '&:disabled': {
          /* fix for Safari disabled input bug https://github.com/primer/css/pull/1707 */
          WebkitTextFillColor: tokens.form.readOnlyTextColor,
          cursor: 'not-allowed',
        },

        '&:read-only': {
          color: tokens.form.readOnlyTextColor,
        },

        /* Focus styles are applied to the wrapper */
        '&:focus': {
          outline: 'none',
        },

        '&::placeholder': {
          color: tokens.fontColorSubtle,
          opacity: 1,
        },

        ...styles.touchScreenFormFieldFontSize,
      },
    },

    hideNumberPickerSpinner: {
      input: {
        '&::-webkit-inner-spin-button': {
          appearance: 'none',
          margin: '0',
        },

        '&::-webkit-outer-spin-button': {
          appearance: 'none',
          margin: '0',
        },

        '&::-ms-clear': {
          display: 'none',
        },

        appearance: 'textfield',
      },
    },

    invalid: {
      wrapper: {
        borderColor: tokens.formElementInputBorderColorError,

        '&:hover': {
          borderColor: tokens.formElementInputBorderColorError,
        },
      },
    },

    disabled: {
      wrapper: {
        backgroundColor: tokens.formElementInputBgColorDisabled,
        opacity: tokens.form.disabledOpacity,
      },
    },

    readOnly: {
      wrapper: {
        backgroundColor: tokens.formElementInputBgColorRead,
        borderColor: tokens.form.readOnlyBorderColor,
      },
    },

    focus: {
      wrapper: {
        outline: `${tokens.focusWidth} solid ${tokens.formElementInputBorderColorActive}`,
        outlineOffset: `-${tokens.focusWidth}`,
        border: `1px solid ${tokens.formElementInputBorderColorActive}`,
      },
    },
  } as const
}
